// extracted by mini-css-extract-plugin
module.exports = {"maincontainer":"Reports_maincontainer__3QPsX","heading":"Reports_heading__3--E_","gridholder":"Reports_gridholder__3nCA-","gridcontainer":"Reports_gridcontainer__3Tgd9"};